//
// FormPoliceSketchContent - Content component for displaying police sketch person details
// Shows person information with optional photo, name, age, and relationship
//

import PropTypes from 'prop-types';
import {
  useMemo,
} from 'react';

import CircularProgress from '../../CircularProgress';
import { Column } from '../../display';

function FormPoliceSketchContent({
  translate,
  fname,
  lname,
  age,
  // gender,
  pic,
  picPending,
  rltn,
}) {
  const firstLineText = useMemo(
    () => (`${(lname || '').toUpperCase()}${fname || ''}${(age === undefined) ? '' : ` (${age}ans)`}`),
    [age, fname, lname],
  );

  const secondLineText = useMemo(
    () => {
      if (rltn) return `Relation: ${translate(rltn)}`;
      return '';
    },
    [rltn, translate],
  );

  return (
    <div className="relative w-full p-1.5 grid grid-cols-[75px_1fr] grid-rows-3 gap-x-2 gap-y-0 justify-items-start items-center justify-start content-start">
      { (pic)
        ? (
            <div className="row-span-3 w-[75px] h-[75px] fill-pxTxtFaint flex items-center justify-center">
              <img
                alt=""
                src={pic}
                className="rounded-md overflow-hidden max-h-[75px] max-w-full object-cover"
              />
            </div>
          )
        : null}

      { ((!pic) && picPending)
        ? (
            <div className="row-span-3 w-[75px] h-[75px] fill-pxTxtFaint flex items-center justify-center">
              <Column>
                <CircularProgress />
              </Column>
            </div>
          )
        : null}

      <div className="row-start-1">
        {firstLineText}
      </div>

      <div className="row-start-2">
        {secondLineText}
      </div>

      <div className="row-start-3" />

    </div>
  );
}

FormPoliceSketchContent.propTypes = {
  translate: PropTypes.func.isRequired,
  fname: PropTypes.string,
  lname: PropTypes.string,
  age: PropTypes.number,
  pic: PropTypes.string,
  picPending: PropTypes.bool,
  rltn: PropTypes.string,
};

export default FormPoliceSketchContent;
